import { TranslationMessages } from '../types';
import { app } from './app/sq';
import { settingsApp } from './app/sq';

const sq: TranslationMessages = {
  nav: {
    howItWorks: 'Si funksionon',
    why: 'Pse?',
    features: 'Veçoritë',
    getStarted: 'FILLO',
    dashboard: 'Paneli',
    blog: 'Blog',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Merr pagesë lehtë',
    subtitle: 'Krijo lidhje pagese menjëherë, menaxho balancën dhe tërhiq në TON. Tarifa e platformës 3%.',
    cta: 'Fillo',
    hairsim: 'Simulo transplantimin e flokëve',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Lidhja e pagesës u krijua.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Abonim mujor',
    stars: 'Stars',
    payBtn: 'Paguaj 100 Stars',
    iPayNow: 'Paguaj tani',
    paymentLabel: 'Pagesë Telegram Stars',
    merchant: 'Tregtar',
    amount: 'Shuma',
    confirmPay: 'Konfirmo pagesën',
    paymentReceived: 'Pagesa u mor — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · kredituar në balancë',
    thanks: 'Faleminderit, aksesi u aktivizua',
    messagePlaceholder: 'Mesazh',
  },
  stats: {
    title: 'I besuar nga mijëra agjentë',
    subtitle: 'Bashkohu me një komunitet në rritje tregtarësh që përdorin pagesat Telegram Stars',
    activeAgents: 'Agjentë aktivë',
    transactions: 'Transaksione',
    uptime: 'Disponueshmëria',
    support: 'Mbështetje',
  },
  features: {
    title: 'Gjithçka që ju nevojitet për të pranuar pagesa Telegram Stars',
    subtitle: 'Një platformë e plotë për menaxhimin e pagesave Telegram Stars',
    instantTitle: 'Krijim i menjëhershëm',
    instantDesc: 'Bëhu agjent në sekonda. Nuk kërkohet konfigurim.',
    balanceTitle: 'Menaxhimi i balancës',
    balanceDesc: 'Ndiq të ardhurat në kohë reale me një panel intuitiv.',
    paymentsTitle: 'Pagesa Telegram Stars',
    paymentsDesc: 'Prano pagesa në Telegram Stars përmes botit tënd.',
    securityTitle: 'Siguri maksimale',
    securityDesc: 'Regjistër i pandryshueshëm, transaksione të sigurta dhe transparente.',
    withdrawTitle: 'Tërheqje TON',
    withdrawDesc: 'Tërhiq fondet direkt në adresën tënde TON.',
    apiTitle: 'API i fuqishëm',
    apiDesc: 'Integrim i lehtë me webhooks dhe API REST të plotë.',
  },
  how: {
    title: 'Si funksionon',
    subtitle: 'Fillo në 3 hapa të thjeshtë',
    startDemo: 'Nis demonstrimin',
    demoRunning: 'Demonstrimi po funksionon...',
    reset: 'Rivendos',
    step1Title: '1. Regjistrohu',
    email: 'Email',
    password: 'Fjalëkalimi',
    noCard: '✓ Nuk kërkohet kartë krediti',
    step2Title: '2. Krijo lidhje pagese',
    amountStars: 'Shuma (Stars)',
    generatedLink: 'Lidhja e gjeneruar:',
    shareLink: '✓ Ndaj këtë lidhje me klientët e tu',
    step3Title: '3. Tërhiq fondet',
    tonAddress: 'Adresa TON',
    availableBalance: 'Balanca e disponueshme:',
    fee: 'Tarifa: 3%',
  },
  pricing: {
    title: 'Çmime të thjeshta dhe transparente',
    subtitle: 'Pa tarifa të fshehura, pa angazhim',
    commission: 'Komisioni',
    perTransaction: 'për transaksion',
    freeAccount: 'Krijim llogarie falas',
    noMonthly: 'Pa tarifa mujore',
    tonWithdrawals: 'Tërheqje TON të integruara',
    completeDashboard: 'Panel i plotë',
    support247: 'Mbështetje 24/7',
    startNow: 'Fillo tani',
  },
  faq: {
    title: 'Pyetje të shpeshta',
    subtitle: 'Gjithçka që duhet të dini për pagesat Telegram Stars',
    q1: 'Si funksionon pagesa Telegram Stars?',
    a1: 'Pagesa Telegram Stars u lejon tregtarëve të pranojnë pagesa direkt përmes Telegram. Përdoruesit krijojnë lidhje pagese, i ndajnë me klientët dhe marrin pagesa në monedhën Telegram Stars.',
    q2: 'Cila është tarifa e platformës?',
    a2: 'Tarifa e platformës është 3% për transaksion. Kjo mbulon përpunimin e pagesave, menaxhimin e regjistrit dhe mirëmbajtjen e platformës. Nuk ka tarifa instalimi ose kosto mujore.',
    q3: 'Si tërheq Telegram Stars?',
    a3: 'Mund të kërkosh tërheqje në portofolin tënd TON. Tërheqjet përpunohen manualisht për siguri. Tërheqja minimale është 100 Stars.',
    q4: 'A është e sigurt pagesa Telegram Stars?',
    a4: 'Po, të gjitha pagesat përpunohen përmes sistemit të sigurt të pagesave të Telegram. Përdorim enkriptim standard të industrisë dhe praktika sigurie.',
    q5: 'Çfarë janë Telegram Stars?',
    a5: 'Telegram Stars është një monedhë virtuale e përdorur brenda Telegram për pagesa. Përdoruesit mund të blejnë Stars dhe t\'i përdorin për të paguar shërbime, produkte dhe abonime.',
    q6: 'A mund të përdor pagesat Telegram Stars për biznesin tim?',
    a6: 'Po! Telegram Stars Payment Platform është krijuar për tregtarë, krijues dhe biznese. Mund të pranosh pagesa për produkte digjitale, shërbime, abonime dhe më shumë.',
  },
  cta: {
    title: 'Gati të fillosh?',
    subtitle: 'Bashkohu me mijëra agjentë që tashmë përdorin platformën tonë',
    createAccount: 'Krijo llogari falas',
    signIn: 'Hyr',
  },
  footer: {
    description: 'Platformë SaaS e plotë për pagesat Telegram Stars',
    product: 'Produkti',
    features: 'Veçoritë',
    pricing: 'Çmimet',
    support: 'Mbështetje',
    signIn: 'Hyr',
    docs: 'Dokumentacioni',
    copyright: '© 2024 Telegram Stars Payment Platform. Të gjitha të drejtat e rezervuara.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Prano pagesa përmes Telegram Stars',
    description: 'Prano pagesa përmes Telegram Stars. Krijo lidhje pagese menjëherë, menaxho balancën dhe tërhiq në TON. Tarifa e platformës 3%. Fillo të pranosh pagesa Telegram Stars sot.',
    keywords: 'pagesë telegram stars, prano telegram stars, telegram stars payment platform, portë pagese telegram stars',
  },
  whyPage: {
    seoTitle: 'Pse të zgjedhësh Telegram Stars Payment Platform | Përfitimet',
    seoDescription: 'Zbuloni pse tregtarët dhe krijuesit zgjedhin Telegram Stars Payment Platform: konfigurim i menjëhershëm, çmime transparente, pagesa të sigurta dhe arritje globale.',
    title: 'Pse të na zgjedhësh?',
    subtitle: 'Krijuar për tregtarë dhe krijues që duan pagesa të thjeshta Telegram Stars',
    r1Title: 'Konfigurim i menjëhershëm',
    r1Desc: 'Fillo në sekonda. Nuk kërkohet konfigurim kompleks ose njohuri teknike.',
    r2Title: 'Çmime transparente',
    r2Desc: 'Vetëm 3% për transaksion. Pa tarifa të fshehura, pa kosto mujore, pa tarifa instalimi.',
    r3Title: 'I sigurt dhe i besueshëm',
    r3Desc: 'I ndërtuar mbi infrastrukturën e sigurt të pagesave të Telegram me enkriptim standard të industrisë.',
    r4Title: 'Arritje globale',
    r4Desc: 'Prano pagesa nga përdoruesit e Telegram në mbarë botën. Pa kufizime gjeografike.',
    r5Title: 'Integrim i lehtë',
    r5Desc: 'API i thjeshtë dhe webhooks. Integrohu me sistemet ekzistuese në minuta.',
    r6Title: 'Tërheqje TON',
    r6Desc: 'Tërhiq direkt në portofolin tënd TON. Tërheqje të shpejta dhe të sigurta.',
  },
  howPage: {
    seoTitle: 'Si funksionon | Telegram Stars Payment Platform',
    seoDescription: 'Mëso si të pranosh pagesa përmes Telegram Stars në 3 hapa të thjeshtë. Krijo llogarinë, gjenero lidhje pagese dhe tërhiq në TON.',
    title: 'Si funksionon',
    subtitle: 'Prano pagesa Telegram Stars në tre hapa të thjeshtë',
  },
  settings: {
    title: "Cilësimet",
    languageSection: "Gjuha",
    defaultLanguage: "Gjuha e paracaktuar",
    languageHint: "Kjo gjuhë zbatohet në të gjithë platformën (faqet dhe ndërfaqen).",
    languageSaved: "Gjuha u përditësua",
    ...settingsApp,
  },
  app,
};

export default sq;
